<template>
  <div class="card-form">
    <form @submit.prevent="checkForm" class="card-form-wrapper">
      <H1>Forgot Password?</H1>
      <TextInput
        v-model="email"
        name="email"
        label="Email"
        type="email"
        :error="errors['email']"
        @input="removeErrorMessage('email', $event)"
      />
      <p class="error" v-if="error">{{ error_message }}</p>
      <div class="card-form-cta">
        <a @click="redirectLogin">Login</a>
        <Button :loading="loading" class="red">Send Password Reset Link</Button>
      </div>
    </form>
  </div>
</template>

<script>
import { H1, TextInput, Button } from "../../style";
import { mapActions } from "vuex";
import { RESET_PASSWORD } from "../../store/types";
export default {
  name: "Reset",
  components: {
    H1,
    TextInput,
    Button
  },
  data() {
    return {
      email: "",
      errors: {
        email: ""
      },
      loading: false,
      error: false
    };
  },
  methods: {
    ...mapActions({
      reset: RESET_PASSWORD,
    }),
    checkForm() {
      let preventSubmit = false;

      if (this.email.trim().length == 0) {
        preventSubmit = true;
        this.errors["email"] = "Email is required";
      }

      if (!preventSubmit) {
        this.submitForm();
      }
    },
    removeErrorMessage(field, value) {
      if (value.trim().length) {
        this.errors[field] = "";
      }
    },
    submitForm() {
      this.error = false;
      this.loading = true;
      this.errors = [];
      this.reset({
        data: {
          email: this.email
        }
      })
        .then(() => {
          this.$notify({
            type: "success",
            title: "Success",
            message: `Reset password was sent to ${this.email} with further instructions`
          });
          this.resetData();
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: "Error",
            message: "Something went wrong"
          });
          this.resetData();
        });      
    },
    resetData() {
      this.loading = false;
      this.email = "";
    },
    redirectLogin() {
      this.$router
        .push("/login")
        .catch();
    }
  }
};
</script>